export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-wilson-api.tracwater.online', // Develop Server
  portalId: '6a17e001e98329553d9006dc',
  portalTypeId: '689596ee18f8a8985a2aebc5',
};
